import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

export enum DEVICE_ONLINE_STATES {
  ONLINE = "online",
  OFFLINE = "offline",
  WARNING = "warning",
}

const getDeviceOnlineState = (updated_at: Date) => {
  const onlineIn24Hours =
    new Date().getTime() - new Date(updated_at).getTime() < 24 * 60 * 60 * 1000;

  const onlineIn12Hours =
    new Date().getTime() - new Date(updated_at).getTime() < 12 * 60 * 60 * 1000;

  if (onlineIn12Hours) return DEVICE_ONLINE_STATES.ONLINE;
  if (onlineIn24Hours) return DEVICE_ONLINE_STATES.WARNING;
  return DEVICE_ONLINE_STATES.OFFLINE;
};

dayjs.extend(relativeTime);
dayjs.extend(utc);

function timeAgo(timestamp: string | number | Date): string {
  const date = dayjs(timestamp);
  const now = dayjs();

  const diffInSeconds = now.diff(date, "second");

  if (diffInSeconds < 60) {
    return `${diffInSeconds} seconds ago`;
  } else if (diffInSeconds < 3600) {
    return `${now.diff(date, "minute")} minutes ago`;
  } else if (diffInSeconds < 86400) {
    return `${now.diff(date, "hour")} hours ago`;
  } else {
    return date.format("MM/DD/YYYY h:mm A");
  }
}

// Example Usage
// console.log(timeAgo("2025-03-15T14:30:00Z")); // Example output: "3 hours ago" OR "03/15/2025 2:30 PM"

export { getDeviceOnlineState, timeAgo };
